const domain = 'https://cortijo-api.aveapplications.com'

export const environment = {
  production: false,

  companyId: 1,
  applicationId: "66e1c7972d51f26e33c1553d", // CSMOBILE
  subApplicationId: "66eb9e0825abd07838474b90", // CSMOBILE-BACKOFFICE
  subApplicationId_csmobile: "66ec55bb62c73fb44fb28540", // CSMOBILE-APP
  hasPermission: false,

  
  PATH_ORDER_INTEGRATOR: null,
  PATH_BP_INTEGRATOR: null,
  PATH_SEND_ERP: null, // '/send-to-erp' NELLY, DIDAC , null others

  API_AUTHENTICATION_URL: `${domain}/authentication/`,
  API_LOCATION_URL: `${domain}/location/`,
  API_ROUTING_URL: `${domain}/routing/`,
  API_AVE_ORDER_URL: 'http://localhost:3000/',
  API_COMMON_URL: `${domain}/common/`,
  API_CONFIGURATION_URL: `${domain}/configuration/`,
  API_DOCUMENT_EXPORT_URL: `${domain}/document-export/`,
  API_MATERIAL_URL: `${domain}/material/`,
  API_BUSINESS_PARTNER: `${domain}/business-partner/`,
  API_NEW_BUSINESS_PARTNER_URL: `${domain}/csm-business-partner/`,
  API_UNIT_MEASURE: `${domain}/master/`,
  API_MATERIAL_PRICE_LIST_URL: `${domain}/material-price-list/`,
  API_PAYMENT_MASTER_URL: `${domain}/payment-master/`,
  API_PAYMENT_ORDER_URL: `${domain}/payment/`,
  API_AVE_AUTHORIZATION_URL: `${domain}/authorization/`,
  API_AVE_INTEGRATOR_URL: `${domain}/integrator/`,
  API_AVE_TRIP_URL: `${domain}/trip/`,
  API_AVE_LIQUIDATION_URL: `${domain}/csm-liquidation/`,
  API_AVE_RETURN: `${domain}/return/`,
  API_AVE_LOAD_PREPARATION: `${domain}/load-preparation/`,
  SUB_ROUTE_LOAD_TEMPLATE:
    "https://albatrosfiles.s3.eu-central-1.amazonaws.com/csmobile/business_partner/Cargar+Ruta-Territorio.xlsx",
  BP_ROUTE_LOAD_TEMPLATE:
    "https://albatrosfiles.s3.eu-central-1.amazonaws.com/csmobile/business_partner/Cargar+Cliente-Territorio+y+Cliente-Frecuencia.xlsx",
  DELIV_ROUTE_LOAD_TEMPLATE:
    "https://albatrosfiles.s3.eu-central-1.amazonaws.com/csmobile/order/Carga_Recarga.xlsx",
  PRICE_LIST_LOAD_TEMPLATE:
    "https://albatrosfiles.s3.eu-central-1.amazonaws.com/csmobile/price_list/Lista_precios.xlsx",
  ORDERS_IMPORT_TEMPLATE_URL:
    "https://albatrosfiles.s3.eu-central-1.amazonaws.com/csmobile/order/Cargar%2BPedidos.xlsx",

  //s3
  URL_AMAZON_S3: null, //portugal, diunsa no tiene
  
  //Ordenes
  projectName: 'CORTIJO', //CORTIJO DIUNSA PORTUGAL
  isDeliveryRouteRequired: false, // TRUE: CORTIJO                //FALSE: DIUNSA, PORTUGAL
  isStockRequired: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isStockRequiredQuotation: false, // TRUE:                        //FALSE: PORTUGAL, CORTIJO, DIUNSA
  isStockCalculatedFromService: false, // TRUE:                        //FALSE: PORTUGAL, CORTIJO, DIUNSA
  isAddressesRequired: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isExpeditionConditionRequired: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isSellerRequired: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isOrderListTrip: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isLostSaleAllowed: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isErpIntegrated: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isProductAndStockCombined: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO
  isSyncIntegratorAllowed: false, //TRUE: PORTUGAL, PHRYMA         //FALSE: CORTIJO, DIUNSA

  //Proyectos con Sincro
  isSync: false, // TRUE: DIUNSA                 //FALSE: PORTUGAL, CORTIJO

  isPriceHistoric: false,
  useShortcuts: true,

  // Sentry Configuration (Activado para testing en QAS)
  enableSentry: true,
  clientName: "CORTIJO",
  appVersion: "20.0.0",
};
